import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  SCShowExportPDF,
  SCCustomerFilterStatement,
  SCCustomerDateError
} from "./css";
import { connect } from "react-redux";
import Moment from "moment";
import { renderCalendarStandard, renderDropDown } from "../Common/FormFields";

import { Button, IconExport } from "@payright/web-components";

import axios from "../../util/payrightAxios";

import {
  Field,
  reduxForm,
  SubmissionError,
  submit as triggerSubmit
} from "redux-form";
import { fetchLoans } from "../../actions/loanActions";
import Loader from "../Common/Loader";
import { RootState } from "../../reducers";

const submit = (values, dispatch) => {
  if (!values.loanNumber) {
    throw new SubmissionError({_error: "Loan number is required."});
  }else if (!values.fromDate){
    throw new SubmissionError({_error: "From date is required."});
  }else if (!values.toDate){
    throw new SubmissionError({_error: "To date is required."});
  };

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const authToken = localStorage.getItem("authToken");
  const url = `${apiBaseUrl}/customer/loans/${values.loanNumber}/statement`;

  axios.defaults.headers.common["auth-token"] = authToken;

  dispatch({type: "FETCH_LOAN_STATEMENT_BEGIN"})

  return axios(url, {
    method: "POST",
    data: values,
    responseType: 'blob', 
  })
    .then(function(response) {
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      const pdfURL = URL.createObjectURL(pdfBlob);

      dispatch({
        type: "FETCH_LOAN_STATEMENT_SUCCESS",
        payload: pdfURL
      });
      window.scrollTo(0, 0);
      
    })
    .catch(async error => {
      const resObj = JSON.parse(await error.response.data.text());
      const errorMessage = resObj.message

      dispatch({type: "FETCH_LOAN_STATEMENT_FAILURE"})
      dispatch({ type: "API_UPDATE_FAILURE", payload: error });
      window.scrollTo(0, 0);
      throw new SubmissionError({_error: errorMessage});
    });
};

let LoanStatementForm = props => {
  const {
    error,
    loading,
    loanStatementURL,
    handleSubmit,
    submitSucceeded,
    dispatch
  } = props;
  const [autoExportOnRetrieve, setAutoExportOnRetrieve] = useState(false);
  const [loanListOptions, setLoanListOptions] = useState([]);

  const { loans } = useSelector<RootState, {loans: any[]}>(state => ({
    loans: state.loans.items
  }));

  const onGenerateAndExport = async () => {
    await dispatch(triggerSubmit("LoanStatementForm"));
    setAutoExportOnRetrieve(true);
  }
  
  // Export
  const onExport = () => {
    const a = document.createElement('a');
    a.download = 'LoanStatement.pdf';
    a.href = loanStatementURL;
    a.addEventListener('click', (e) => {
      setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
    });
    a.click();
  };

  const getLoanList = (loanList) => {
    return loanList.map(obj => ({
      name: obj.loanName.name, 
      value: obj.ID
    }));
  }

  // Automatically exports to pdf if the autoExportOnRetrieve flag is set to true (i.e. the exportFromMobile buttton is clicked)
  useEffect(() => {
    if (
      autoExportOnRetrieve === true &&
      submitSucceeded === true && loanStatementURL
    ) {
      setAutoExportOnRetrieve(false); // Reset the flag
      onExport();
    }
  }, [submitSucceeded, autoExportOnRetrieve, loanStatementURL]);

  useEffect(() => {
    if (!loans && !error)  {
      dispatch(fetchLoans());
    }
    if (loans && !error) {
      setLoanListOptions(getLoanList(loans));
    }
  }, [dispatch, loans, error]);

  let displayStatementForScreen;

  if (submitSucceeded === true) {
    if (loanStatementURL !== null) {
      displayStatementForScreen = (
        <>
        <object
          data={loanStatementURL + '#toolbar=0&navpanes=0&scrollbar=0'}
          type="application/pdf"
        />
        </>
      );
    }
  } else if (error !== undefined) {
    displayStatementForScreen = (
      <SCCustomerDateError>{error}</SCCustomerDateError>
    );
  }

  return (
    <>
      <SCCustomerFilterStatement>
        <form className="StatementForm" onSubmit={handleSubmit}>
          <div className="containerStatement">
            <Field
              className="loanNumberDropdown"
              label="Loan Number"
              name="loanNumber"
              options={loanListOptions}
              component={renderDropDown}
            />
        
            <Field
              label="From Date"
              name="fromDate"
              maxWidth="50%"
              component={renderCalendarStandard}
            />
            <Field
              label="To Date"
              name="toDate"
              maxWidth="50%"
              component={renderCalendarStandard}
            />
            <Button
              colour="blue"
              size="small"
              outline
              icon={<IconExport />}
              iconPosition="left"
              type="submit"
              className="statementButton export-btn"
            >
              {" "}
              Generate Statement
            </Button>
            <Button
              type="button"
              colour="blue"
              size="small"
              outline
              handleClick={onGenerateAndExport}
              className="mobileStatementButton export-btn"
            >
              {" "}
              Generate and export Statement
            </Button>

            {submitSucceeded === true &&
            loanStatementURL !== null ? (
              <Button
                type="button"
                colour="blue"
                size="small"
                outline
                handleClick={onExport}
                icon={<IconExport />}
                iconPosition="left"
                className="statementButton export-btn"
              >
                {" "}
                Export Statement
              </Button>
            ) : (
              ""
            )}
          </div>
        </form>
      </SCCustomerFilterStatement>

      <SCShowExportPDF>
        <div className="pdfMainContent">
          {displayStatementForScreen}
        </div>
      </SCShowExportPDF>
      {loading ? <Loader text="Fetching statement..." /> : ("")}
    </>
  );
};

LoanStatementForm = reduxForm({
  form: "LoanStatementForm",
  enableReinitialize: true,
  onSubmit: submit,
})(LoanStatementForm);

const mapStateToProps = function(state) {
  return {
    initialValues: {
      fromDate: Moment()
        .subtract(1, "days")
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      toDate: Moment().format("YYYY-MM-DD"),
      loanNumber: null,
    },
    loanStatementURL: state.pageData.loanStatementURL,
    error: state.pageData.error,
    loading: state.pageData.loading
  };
};
export default connect(mapStateToProps)(LoanStatementForm);

